const AdditionalProduct = () => (
    <div>
        <h3>Fender 68 custom</h3>
    </div>
);

export default AdditionalProduct;
